import {
  questionsNamespace,
  referralRequestDetailNameSpace,
  referralRequestsNamespace,
  performanceNamespace,
  accountNamespace,
  callHistoryNamespace,
  payPerLeadDetailNamespace,
  payPerLeadNamespace,
  proBonoNamespace,
  proBonoDetailNamespace,
  listingNamespace,
  paymentNamespace,
  homeNamespace,
  signUpNamespace,
  authNamespace,
  mainNamespace,
  messagesNamespace,
  searchResultNameSpace,
  teamsNameSpace,
  landingNamespace,
  publicListingsNameSpace,
  searchNameSpace,
  partnersNameSpace,
  followingNameSpace
} from "./actionsNamespaces";

export const main = {
  GET_UTILITY_LISTING: `${mainNamespace}GET_UTILITY_LISTING`,
  MARK_READ: `${mainNamespace}MARK_READ`,
  GET_UTILITY_LISTING_FAIL: `${mainNamespace}GET_UTILITY_LISTING_FAIL`,
  GET_FOOTER_INFO: `${mainNamespace}GET_FOOTER_INFO`,
  GET_FOOTER_INFO_FAIL: `${mainNamespace}GET_FOOTER_INFO_FAIL`,
  SET_LOADING: `${mainNamespace}SET_LOADING`,
  GET_LOGIN: `${mainNamespace}GET_LOGIN`,
  GET_LOGIN_FAIL: `${mainNamespace}GET_LOGIN_FAIL`,
  SEND_EMAIL_VERIFY_CODE_SUCCESS: `${mainNamespace}SEND_EMAIL_VERIFY_CODE_SUCCESS`,
  SEND_EMAIL_VERIFY_CODE_FAIL: `${mainNamespace}SEND_EMAIL_VERIFY_CODE_FAIL`,
  CHECK_EMAIL_VERIFY_CODE_SUCCESS: `${mainNamespace}CHECK_EMAIL_VERIFY_CODE_SUCCESS`,
  CHECK_EMAIL_VERIFY_CODE_FAIL: `${mainNamespace}CHECK_EMAIL_VERIFY_CODE_FAIL`,
  TOGGLE_PAYMENT_ERROR: `${mainNamespace}TOGGLE_PAYMENT_ERROR`,
  TOGGLE_NEW_LISTING: `${mainNamespace}TOGGLE_NEW_LISTING`,
  TOGGLE_MOBILE_MENU: `${mainNamespace}TOGGLE_MOBILE_MENU`,
  GET_COMMUNITIES: `${mainNamespace}GET_COMMUNITIES`
};

export const landing = {
  SET_LOADING: `${landingNamespace}SET_LOADING`,
  GET_COUNTRIES: `${landingNamespace}GET_COUNTRIES`,
  GET_PRACTICES: `${landingNamespace}GET_PRACTICES`,
  GET_PRACTICES_FAIL: `${landingNamespace}GET_PRACTICES_FAIL`,
  GET_PROFESSIONS: `${landingNamespace}GET_PROFESSIONS`,
  GET_PROFESSIONS_FAIL: `${landingNamespace}GET_PROFESSIONS_FAIL`,
  GET_CITY_STATE: `${landingNamespace}GET_CITY_STATE`,
  GET_CITY_STATE_FAIL: `${landingNamespace}GET_CITY_STATE_FAIL`,
  GET_COUNTRIES_FAIL: `${landingNamespace}GET_COUNTRIES_FAIL`
};

export const search = {
  SET_LOADING: `${searchNameSpace}SET_LOADING`,
  GET_PRACTICES: `${searchNameSpace}GET_PRACTICES`,
  GET_PRACTICES_FAIL: `${searchNameSpace}GET_PRACTICES_FAIL`,
  GET_PROFESSIONS: `${searchNameSpace}GET_PROFESSIONS`,
  GET_PROFESSIONS_FAIL: `${searchNameSpace}GET_PROFESSIONS_FAIL`
};

export const auth = {
  SET_LOADING: `${authNamespace}SET_LOADING`,
  SET_SUCCESS: `${authNamespace}SET_SUCCESS`,
  SET_ERRORS: `${authNamespace}SET_ERRORS`,
  SET_LOGGED_IN: `${authNamespace}SET_LOGGED_IN`,
  RESET_PASSWORD: `${authNamespace}RESET_PASSWORD`,
  RESET_PASSWORD_FAIL: `${authNamespace}RESET_PASSWORD_FAIL`,
  RESET_PASSWORD_FAIL_NOT_EXIST: `${authNamespace}RESET_PASSWORD_FAIL_NOT_EXIST`,
  SET_NEW_PASSWORD: `${authNamespace}SET_NEW_PASSWORD`,
  SET_NEW_PASSWORD_FAIL: `${authNamespace}SET_NEW_PASSWORD_FAIL`,
  LOGIN_SUCCESS: `${authNamespace}LOGIN_SUCCESS`,
  LOGIN_FAIL: `${authNamespace}LOGIN_FAIL`,
  LOGOUT: `${authNamespace}LOGOUT`,
  ACCOUNT_UNAVAILABLE: `${authNamespace}ACCOUNT_UNAVAILABLE`,
  SET_LOGIN_METHODS: `${authNamespace}SET_LOGIN_METHODS`,
  SET_GOOGLE_AUTH_ID: `${authNamespace}SET_GOOGLE_AUTH_ID`,
  SET_GOOGLE_AUTH_RESPONSE: `${authNamespace}SET_GOOGLE_AUTH_RESPONSE`,
  VERIFICATION_CODE: `${authNamespace}VERIFICATION_CODE`,
  VERIFICATION_CODE_FAIL: `${authNamespace}VERIFICATION_CODE_FAIL`,
  KEYCLOACK_FAIL: `${authNamespace}KEYCLOACK_FAIL`
};

export const signUp = {
  SET_LOADING: `${signUpNamespace}SET_LOADING`,
  SET_SUCCESS: `${signUpNamespace}SET_SUCCESS`,
  GET_PROFESSIONS: `${signUpNamespace}GET_PROFESSIONS`,
  CLEAN_PROFESSIONAL: `${signUpNamespace}CLEAN_PROFESSIONAL`,
  GET_PROFESSIONS_FAIL: `${signUpNamespace}GET_PROFESSIONS_FAIL`,
  GET_PROFESSIONS_LOADING: `${signUpNamespace}GET_PROFESSIONS_LOADING`,
  GET_PROFESSIONS_LIST: `${signUpNamespace}GET_PROFESSIONS_LIST`,
  GET_COUNTRIES_LIST: `${signUpNamespace}GET_COUNTRIES_LIST`,
  GET_COUNTRIES_LIST_FAIL: `${signUpNamespace}GET_COUNTRIES_LIST_FAIL`,
  SET_ERRORS: `${signUpNamespace}SET_ERRORS`,
  SIGNUP: `${signUpNamespace}SIGNUP`,
  SIGNUP_FAIL: `${signUpNamespace}FAIL`
};

export const home = {
  GET_UTILITY_LISTING: `${homeNamespace}GET_UTILITY_LISTING`,
  REMOVE_ALL_ERROR: `${homeNamespace}REMOVE_ALL_ERROR`,
  SET_LOADING: `${homeNamespace}SET_LOADING`,
  GET_DASHBOARD_DATA: `${homeNamespace}GET_DASHBOARD_DATA`,
  GET_DASHBOARD_DATA_SUCCESS: `${homeNamespace}GET_DASHBOARD_DATA_SUCCESS`,
  GET_DASHBOARD_DATA_FAIL: `${homeNamespace}GET_DASHBOARD_DATA_FAIL`,
  MARK_READ: `${homeNamespace}MARK_READ`,
  MARK_UNREAD: `${homeNamespace}MARK_UNREAD`,
  GET_ADD_NEW_LISTING_DATA: `${homeNamespace}GET_ADD_NEW_LISTING_DATA`,
  GET_ADD_NEW_LISTING_DATA_FAIL: `${homeNamespace}GET_ADD_NEW_LISTING_DATA_FAIL`,
  ADD_NEW_LISTING: `${homeNamespace}ADD_NEW_LISTING`,
  ADD_NEW_LISTING_FAIL: `${homeNamespace}ADD_NEW_LISTING_FAIL`,
  GET_SAVED: `${homeNamespace}GET_SAVED`,
  GET_MY_FEED: `${homeNamespace}GET_MY_FEED`,
  REMOVE_FOLLOWING: `${homeNamespace}REMOVE_FOLLOWING`,
  REMOVE_FOLLOWING_FAIL: `${homeNamespace}REMOVE_FOLLOWING_FAIL`,
  GET_FOLLOWING: `${homeNamespace}GET_FOLLOWING`,
  GET_FOLLOWING_FAIL: `${homeNamespace}GET_FOLLOWING_FAIL`,
  GET_MY_FEED_FAIL: `${homeNamespace}GET_MY_FEED_FAIL`,
  GET_SAVED_FAIL: `${homeNamespace}GET_SAVED_FAIL`,
  ADD_FAVORITES: `${homeNamespace}ADD_FAVORITES`,
  ADD_FAVORITES_FAIL: `${homeNamespace}ADD_FAVORITES_FAIL`,
  REMOVE_FAVORITES: `${homeNamespace}REMOVE_FAVORITES`,
  REMOVE_FAVORITES_FAIL: `${homeNamespace}REMOVE_FAVORITES_FAIL`,
  // My Feed v2 stream (GROWTH-7129) — GET /api-v2/feed
  GET_FEED_STREAM: `${homeNamespace}GET_FEED_STREAM`,
  GET_FEED_STREAM_FAIL: `${homeNamespace}GET_FEED_STREAM_FAIL`,
  // POST /api-v2/feed/seen (GROWTH-7128)
  MARK_FEED_SEEN_FAIL: `${homeNamespace}MARK_FEED_SEEN_FAIL`,
  // Saved tab in the v2 card shape (GROWTH-7140) — GET /api-v2/feed/saved
  GET_SAVED_FEED: `${homeNamespace}GET_SAVED_FEED`,
  GET_SAVED_FEED_FAIL: `${homeNamespace}GET_SAVED_FEED_FAIL`,
  REMOVE_SAVED_FEED_ITEM: `${homeNamespace}REMOVE_SAVED_FEED_ITEM`,
  // Feed card Message CTA (GROWTH-7132) — POST /members/json-api/public/send-message
  SEND_FEED_MESSAGE: `${homeNamespace}SEND_FEED_MESSAGE`,
  SEND_FEED_MESSAGE_FAIL: `${homeNamespace}SEND_FEED_MESSAGE_FAIL`,
  // Upcoming-events strip (GROWTH-7131) — GET /api-v2/feed/upcoming-events
  GET_UPCOMING_EVENTS: `${homeNamespace}GET_UPCOMING_EVENTS`,
  GET_UPCOMING_EVENTS_FAIL: `${homeNamespace}GET_UPCOMING_EVENTS_FAIL`
};

export const payment = {
  SET_LOADING: `${paymentNamespace}SET_LOADING`,
  GET_PAYMENT_METHODS: `${paymentNamespace}GET_PAYMENT_METHODS`,
  SET_SELECTED_CARD: `${paymentNamespace}SET_SELECTED_CARD`,
  GET_PAYMENT_METHODS_FAIL: `${paymentNamespace}GET_PAYMENT_METHODS_FAIL`,
  GET_PAYMENT_HISTORY: `${paymentNamespace}GET_PAYMENT_HISTORY`,
  UPDATE_PAYMENT_METHOD: `${paymentNamespace}UPDATE_PAYMENT_METHOD`,
  UPDATE_PAYMENT_METHOD_FAIL: `${paymentNamespace}UPDATE_PAYMENT_METHOD_FAIL`,
  UPDATE_PAYMENT_METHOD_RESET: `${paymentNamespace}UPDATE_PAYMENT_METHOD_RESET`,
  GET_PAYMENT_HISTORY_FAIL: `${paymentNamespace}GET_PAYMENT_HISTORY_FAIL`,
  ADD_CARD: `${paymentNamespace}ADD_CARD`,
  ADD_CARD_SUCCESS: `${paymentNamespace}ADD_CARD_SUCCESS`,
  ADD_CARD_LOCALLY: `${paymentNamespace}ADD_CARD_LOCALLY`,
  ADD_CARD_FAIL: `${paymentNamespace}ADD_CARD_FAIL`,
  UPDATE_CARD_SUCCESS: `${paymentNamespace}UPDATE_CARD_SUCCESS`,
  UPDATE_CARD_LOCALLY: `${paymentNamespace}UPDATE_CARD_LOCALLY`,
  UPDATE_CARD_FAIL: `${paymentNamespace}UPDATE_CARD_FAIL`,
  DELETE_CARD_SUCCESS: `${paymentNamespace}DELETE_CARD_SUCCESS`,
  DELETE_CARD_LOCALLY: `${paymentNamespace}DELETE_CARD_LOCALLY`,
  SET_DEFAULT_SOURCE: `${paymentNamespace}SET_DEFAULT_SOURCE`,
  CHARGE_FOR_MEMBERSHIP: `${paymentNamespace}CHARGE_FOR_MEMBERSHIP`,
  CHARGE_FOR_MEMBERSHIP_SUCCESS: `${paymentNamespace}CHARGE_FOR_MEMBERSHIP_SUCCESS`,
  CHARGE_FOR_MEMBERSHIP_FAIL: `${paymentNamespace}CHARGE_FOR_MEMBERSHIP_FAIL`,
  SET_STRIPE_TOKEN: `${paymentNamespace}SET_STRIPE_TOKEN:`,
  GET_ERROR_TOKEN: `${paymentNamespace}GET_ERROR_TOKEN`,
  CLEAR_ERROR_TOKEN: `${paymentNamespace}CLEAR_ERROR_TOKEN`,
  CLEAR_STATE: `${paymentNamespace}CLEAR_STATE`,
  CLEAR_SUCCESS: `${paymentNamespace}CLEAR_SUCCESS`,
  RESET_PAYMENT_HISTORY: `${paymentNamespace}RESET_PAYMENT_HISTORY`
};

export const account = {
  SET_LOADING: `${accountNamespace}SET_LOADING`,
  TOGGLE_ACTIVITY_OF_MODAL: `${accountNamespace}TOGGLE_ACTIVITY_OF_MODAL`,
  CLEAR_ALL_MODALS: `${accountNamespace}CLEAR_ALL_MODALS`,
  GET_PROFILE: `${accountNamespace}GET_PROFILE`,
  SET_INBOX_COUNTS: `${accountNamespace}SET_INBOX_COUNTS`,
  SET_PROFILE_COMPLETION: `${accountNamespace}SET_PROFILE_COMPLETION`,
  MARK_READ_NOTIFICATION: `${accountNamespace}MARK_READ_NOTIFICATION`,
  MARK_UN_READ_NOTIFICATION: `${accountNamespace}MARK_UN_READ_NOTIFICATION`,
  MARK_READ_ALL_NOTIFICATION: `${accountNamespace}MARK_READ_ALL_NOTIFICATION`,
  GET_PROFILE_FAIL: `${accountNamespace}GET_PROFILE_FAIL`,
  UPDATE_CONTACTS: `${accountNamespace}UPDATE_CONTACTS`,
  UPDATE_CONTACTS_SUCCESS: `${accountNamespace}UPDATE_CONTACTS_SUCCESS`,
  UPDATE_CONTACTS_FAIL: `${accountNamespace}UPDATE_CONTACTS_FAIL`,
  UPDATE_PASSWORD: `${accountNamespace}UPDATE_PASSWORD`,
  UPDATE_PASSWORD_SUCCESS: `${accountNamespace}UPDATE_PASSWORD_SUCCESS`,
  UPDATE_PASSWORD_FAIL: `${accountNamespace}UPDATE_PASSWORD_FAIL`,
  GET_NOTIFICATION_SETTINGS: `${accountNamespace}GET_NOTIFICATION_SETTINGS`,
  GET_NOTIFICATION_SETTINGS_FAIL: `${accountNamespace}GET_NOTIFICATION_SETTINGS_FAIL`,
  NOTIFICATIONS_V2_ACCOUNT_REQUEST: `${accountNamespace}NOTIFICATIONS_V2_ACCOUNT_REQUEST`,
  NOTIFICATIONS_V2_ACCOUNT_SUCCESS: `${accountNamespace}NOTIFICATIONS_V2_ACCOUNT_SUCCESS`,
  NOTIFICATIONS_V2_ACCOUNT_FAIL: `${accountNamespace}NOTIFICATIONS_V2_ACCOUNT_FAIL`,
  NOTIFICATIONS_V2_LISTINGS_REQUEST: `${accountNamespace}NOTIFICATIONS_V2_LISTINGS_REQUEST`,
  NOTIFICATIONS_V2_LISTINGS_SUCCESS: `${accountNamespace}NOTIFICATIONS_V2_LISTINGS_SUCCESS`,
  NOTIFICATIONS_V2_LISTINGS_FAIL: `${accountNamespace}NOTIFICATIONS_V2_LISTINGS_FAIL`,
  NOTIFICATIONS_V2_PREFERENCE_SAVING: `${accountNamespace}NOTIFICATIONS_V2_PREFERENCE_SAVING`,
  NOTIFICATIONS_V2_PREFERENCE_SAVED: `${accountNamespace}NOTIFICATIONS_V2_PREFERENCE_SAVED`,
  NOTIFICATIONS_V2_PREFERENCE_CLEARED: `${accountNamespace}NOTIFICATIONS_V2_PREFERENCE_CLEARED`,
  NOTIFICATIONS_V2_PREFERENCE_FAILED: `${accountNamespace}NOTIFICATIONS_V2_PREFERENCE_FAILED`,
  UPDATE_NOTIFICATIONS_SUCCESS: `${accountNamespace}UPDATE_NOTIFICATIONS_SUCCESS`,
  UPDATE_NOTIFICATIONS_FAIL: `${accountNamespace}UPDATE_NOTIFICATIONS_FAIL`,
  UPDATE_NEWSLETTERS_SUCCESS: `${accountNamespace}UPDATE_NEWSLETTERS_SUCCESS`,
  UPDATE_NEWSLETTERS_FAIL: `${accountNamespace}UPDATE_NEWSLETTERS_FAIL`,
  EMAIL_SEND_VERIFY_CODE_SUCCESS: `${accountNamespace}EMAIL_SEND_VERIFY_CODE_SUCCESS`,
  EMAIL_VERIFY_CODE_SUCCESS: `${accountNamespace}EMAIL_VERIFY_CODE_SUCCESS`,
  EMAIL_VERIFY_CODE_FAIL: `${accountNamespace}EMAIL_VERIFY_CODE_FAIL`,
  EMAIL_VERIFY_CODE_CLEAR_ERROR: `${accountNamespace}EMAIL_VERIFY_CODE_CLEAR_ERROR`,
  CHECK_EMAIL_VERIFY_CODE_FAIL: `${accountNamespace}CHECK_EMAIL_VERIFY_CODE_FAIL`,
  UPDATE_EMAIL_SUCCESS: `${accountNamespace}UPDATE_EMAIL_SUCCESS`,
  VERIFIED_EMAIL_SUCCESS: `${accountNamespace}VERIFIED_EMAIL_SUCCESS`,
  UPDATE_EMAIL_FAIL: `${accountNamespace}UPDATE_EMAIL_FAIL`,
  SAVE_NEW_EMAIL_PASSWORD: `${accountNamespace}SAVE_NEW_EMAIL_PASSWORD`,
  CLEAN_NEW_EMAIL_PASSWORD: `${accountNamespace}CLEAN_NEW_EMAIL_PASSWORD`,
  PHONE_VERIFY_CODE_SUCCESS: `${accountNamespace}PHONE_VERIFY_CODE_SUCCESS`,
  PHONE_VERIFY_CODE_FAIL: `${accountNamespace}PHONE_VERIFY_CODE_FAIL`,
  CHECK_PHONE_VERIFY_CODE_FAIL: `${accountNamespace}CHECK_PHONE_VERIFY_CODE_FAIL`,
  UPDATE_PHONE_SUCCESS: `${accountNamespace}UPDATE_PHONE_SUCCESS`,
  REMOVE_PHONE_SUCCESS: `${accountNamespace}REMOVE_PHONE_SUCCESS`,
  REMOVE_PHONE_FAIL: `${accountNamespace}REMOVE_PHONE_FAIL`,
  EMAIL_VERIFICATION_CHANGE: `${accountNamespace}EMAIL_VERIFICATION_CHANGE`,
  PHONE_VERIFICATION_CHANGE: `${accountNamespace}PHONE_VERIFICATION_CHANGE`,
  PASSWORD_VERIFICATION_SUCCESS: `${accountNamespace}PASSWORD_VERIFICATION_SUCCESS`,
  NOTIFICATION_REMOVE_EMAIL_SUCCESS: `${accountNamespace}NOTIFICATION_REMOVE_EMAIL_SUCCESS`,
  NOTIFICATION_REMOVE_EMAIL_FAIL: `${accountNamespace}NOTIFICATION_REMOVE_EMAIL_FAIL`,
  NOTIFICATION_REMOVE_PHONE_SUCCESS: `${accountNamespace}NOTIFICATION_REMOVE_PHONE_SUCCESS`,
  NOTIFICATION_REMOVE_PHONE_FAIL: `${accountNamespace}NOTIFICATION_REMOVE_PHONE_FAIL`
};

export const listing = {
  CLEAR_CHANGES_FIELD: `${listingNamespace}CLEAR_CHANGES_FIELD`,
  CLEAR_ALL_MODALS: `${listingNamespace}CLEAR_ALL_MODALS`,
  DELETE_SUCCESS: `${listingNamespace}DELETE_SUCCESS`,
  DELETE_FAIL: `${listingNamespace}DELETE_FAIL`,
  PAUSE_FAIL: `${listingNamespace}PAUSE_FAIL`,
  PAUSE_SUCCESS: `${listingNamespace}PAUSE_SUCCESS`,
  UNPAUSE_SUCCESS: `${listingNamespace}UNPAUSE_SUCCESS`,
  UNPAUSE_FAIL: `${listingNamespace}UNPAUSE_FAIL`,
  DOWNGRADE_FAIL: `${listingNamespace}DOWNGRADE_FAIL`,
  UN_DOWNGRADE_FAIL: `${listingNamespace}UN_DOWNGRADE_FAIL`,
  DOWNGRADE_SUCCESS: `${listingNamespace}DOWNGRADE_SUCCESS`,
  UN_DOWNGRADE_SUCCESS: `${listingNamespace}UN_DOWNGRADE_SUCCESS`,
  GET_MEMBERSHIPS: `${listingNamespace}GET_MEMBERSHIPS`,
  GET_MEMBERSHIPS_FAIL: `${listingNamespace}GET_MEMBERSHIPS_FAIL`,
  SET_MEMBERSHIP_DATA_CLEAR: `${listingNamespace}SET_MEMBERSHIP_DATA_CLEAR`,
  GET_UPGRADE_OPTIONS: `${listingNamespace}GET_UPGRADE_OPTIONS`,
  GET_UPGRADE_OPTIONS_FAIL: `${listingNamespace}GET_UPGRADE_OPTIONS_FAIL`,
  GET_UPGRADE_OPTIONS_SHOW_ERROR: `${listingNamespace}GET_UPGRADE_OPTIONS_SHOW_ERROR`,
  GET_UPGRADE_OPTIONS_HIDE_ERROR: `${listingNamespace}GET_UPGRADE_OPTIONS_HIDE_ERROR`,
  SET_LOADING: `${listingNamespace}SET_LOADING`,
  SET_UNSAVED_SECTION: `${listingNamespace}SET_UNSAVED_SECTION`,
  GET_MEMBER_DATA: `${listingNamespace}GET_MEMBER_DATA`,
  SUBMIT_PHONE_EMAIL_SUCCESS: `${listingNamespace}SUBMIT_PHONE_EMAIL_SUCCESS`,
  GET_MEMBER_DATA_FAIL: `${listingNamespace}GET_MEMBER_DATA_FAIL`,
  SET_DEFAULT_MEMBER_DATA: `${listingNamespace}SET_DEFAULT_MEMBER_DATA`,
  UPDATE_ACTIVE_UPGRADE_OPTIONS: `${listingNamespace}UPDATE_ACTIVE_UPGRADE_OPTIONS`,
  PUBLISH_LISTING: `${listingNamespace}PUBLISH_LISTING`,
  PUBLISH_LISTING_FAIL: `${listingNamespace}PUBLISH_LISTING_FAIL`,
  DELETE_ADDITIONAL_IMAGE: `${listingNamespace}DELETE_ADDITIONAL_IMAGE`,
  DELETE_COVER_IMAGE: `${listingNamespace}DELETE_COVER_IMAGE`,
  DELETE_PARENT_COVER_IMAGE: `${listingNamespace}DELETE_PARENT_COVER_IMAGE`,
  GET_VALIDATIONS: `${listingNamespace}GET_VALIDATIONS`,
  GET_VALIDATIONS_FAIL: `${listingNamespace}GET_VALIDATIONS_FAIL`,
  DELETE_IMAGE_FAIL: `${listingNamespace}DELETE_IMAGE_FAIL`,
  GET_NOTIFICATION_TYPES_SUCCESS: `${listingNamespace}GET_NOTIFICATION_TYPES_SUCCESS`,
  GET_NOTIFICATION_TYPES_FAIL: `${listingNamespace}GET_NOTIFICATION_TYPES_FAIL`,
  GET_DIRECT_MESSAGES_SUCCESS: `${listingNamespace}GET_DIRECT_MESSAGES_SUCCESS`,
  GET_DIRECT_MESSAGES_FAIL: `${listingNamespace}GET_DIRECT_MESSAGES_FAIL`,
  GET_DONATIONS_SETTINGS_SUCCESS: `${listingNamespace}GET_DONATIONS_SETTINGS_SUCCESS`,
  GET_DONATIONS_SETTINGS_FAIL: `${listingNamespace}GET_DONATIONS_SETTINGS_FAIL`,
  GET_DONATIONS_ACTIVITY_SUCCESS: `${listingNamespace}GET_DONATIONS_ACTIVITY_SUCCESS`,
  GET_DONATIONS_ACTIVITY_FAIL: `${listingNamespace}GET_DONATIONS_ACTIVITY_FAIL`,
  GET_LISTING_SECTION_HIDE_SUCCESS: `${listingNamespace}GET_LISTING_SECTION_HIDE_SUCCESS`,
  GET_LISTING_SECTION_HIDE_FAIL: `${listingNamespace}GET_LISTING_SECTION_HIDE_FAIL`,
  UPDATE_LISTING_SECTION_HIDE_SUCCESS: `${listingNamespace}UPDATE_LISTING_SECTION_HIDE_SUCCESS`,
  UPDATE_LISTING_SECTION_HIDE_FAIL: `${listingNamespace}UPDATE_LISTING_SECTION_HIDE_FAIL`,
  UPDATE_NOTIFICATION_TYPE: `${listingNamespace}UPDATE_NOTIFICATION_TYPE`,
  UPDATE_NOTIFICATION_TYPE_SUCCESS: `${listingNamespace}UPDATE_NOTIFICATION_TYPE_SUCCESS`,
  UPDATE_NOTIFICATION_TYPE_ROLLBACK: `${listingNamespace}UPDATE_NOTIFICATION_TYPE_ROLLBACK`,
  CREATE_NOTIFICATION_TYPE_SUCCESS: `${listingNamespace}CREATE_NOTIFICATION_TYPE_SUCCESS`,
  CREATE_NOTIFICATION_TYPE_FAIL: `${listingNamespace}CREATE_NOTIFICATION_TYPE_FAIL`,
  UPDATE_DIRECT_MESSAGES_SUCCESS: `${listingNamespace}UPDATE_DIRECT_MESSAGES_SUCCESS`,
  UPDATE_DIRECT_MESSAGES_FAIL: `${listingNamespace}UPDATE_DIRECT_MESSAGES_FAIL`,
  DELETE_COVER_IMAGE_FAIL: `${listingNamespace}DELETE_COVER_IMAGE_FAIL`,
  SET_SUCCESS: `${listingNamespace}SET_SUCCESS`,
  SUBMIT_CHANGES_FAIL: `${listingNamespace}SUBMIT_CHANGES_FAIL`,
  RESET_DRAFT_FAIL: `${listingNamespace}RESET_DRAFT_FAIL`,
  SUBMIT_CHANGES_CLOSE_MODALS: `${listingNamespace}SUBMIT_CHANGES_CLOSE_MODALS`,
  UPGRADE_CLEAN: `${listingNamespace}UPGRADE_CLEAN`,
  TOGGLE_ACTIVITY_OF_MODAL: `${listingNamespace}TOGGLE_ACTIVITY_OF_MODAL`,
  ACTIVE_NOTIFICATION_MODAL: `${listingNamespace}ACTIVE_NOTIFICATION_MODAL`,
  NOTIFICATIONS_LOADING: `${listingNamespace}NOTIFICATIONS_LOADING`,
  NOTIFICATION_EMAIL: `${listingNamespace}NOTIFICATION_EMAIL`,
  NOTIFICATION_EMAIL_FAIL: `${listingNamespace}NOTIFICATION_EMAIL_FAIL`,
  NOTIFICATION_VERIFICATION_EMAIL_FAIL: `${listingNamespace}NOTIFICATION_VERIFICATION_EMAIL_FAIL`,
  NOTIFICATION_VERIFICATION_EMAIL_SUCCESS: `${listingNamespace}NOTIFICATION_VERIFICATION_EMAIL_SUCCESS`,
  NOTIFICATION_VERIFICATION_PHONE_FAIL: `${listingNamespace}NOTIFICATION_VERIFICATION_PHONE_FAIL`,
  NOTIFICATION_VERIFICATION_PHONE_SUCCESS: `${listingNamespace}NOTIFICATION_VERIFICATION_PHONE_SUCCESS`,
  NOTIFICATION_PHONE: `${listingNamespace}NOTIFICATION_PHONE`,
  NOTIFICATION_PHONE_FAIL: `${listingNamespace}NOTIFICATION_PHONE_FAIL`,
  RESET_NOTIFICATION_STATE: `${listingNamespace}RESET_NOTIFICATION_STATE`,
  SET_SAVED_PAYMENT_DATA: `${listingNamespace}SET_SAVED_PAYMENT_DATA`,
  CLEAR_SAVED_PAYMENT_DATA: `${listingNamespace}CLEAR_SAVED_PAYMENT_DATA`,
  GET_LISTING_ASSISTANT: `${listingNamespace}GET_LISTING_ASSISTANT`,
  GET_DIRECTORIES_PROFESSIONS: `${listingNamespace}GET_DIRECTORIES_PROFESSIONS`,
  GET_DIRECTORIES_PROFESSIONS_FAIL: `${listingNamespace}GET_DIRECTORIES_PROFESSIONS_FAIL`,
  GET_LISTINGS_CONFIG: `${listingNamespace}GET_LISTINGS_CONFIG`,
  GET_LISTINGS_CONFIG_FAIL: `${listingNamespace}GET_LISTINGS_CONFIG_FAIL`,
  SET_VALIDATION_ERROR: `${listingNamespace}SET_VALIDATION_ERROR`,
  DELETE_PRIMARY_IMAGE: `${listingNamespace}DELETE_PRIMARY_IMAGE`,
  DELETE_PRIMARY_IMAGE_FAIL: `${listingNamespace}DELETE_PRIMARY_IMAGE_FAIL`,
  CLEAR_ERROR: `${listingNamespace}CLEAR_ERROR`,
  CLEAR_PHOTO_ERROR: `${listingNamespace}CLEAR_PHOTO_ERROR`,
  // AI Content Generation
  AI_GENERATE_DESCRIPTION: `${listingNamespace}AI_GENERATE_DESCRIPTION`,
  AI_GENERATE_DESCRIPTION_SUCCESS: `${listingNamespace}AI_GENERATE_DESCRIPTION_SUCCESS`,
  AI_GENERATE_DESCRIPTION_FAIL: `${listingNamespace}AI_GENERATE_DESCRIPTION_FAIL`,
  AI_GENERATE_TRANSLATION: `${listingNamespace}AI_GENERATE_TRANSLATION`,
  AI_GENERATE_TRANSLATION_SUCCESS: `${listingNamespace}AI_GENERATE_TRANSLATION_SUCCESS`,
  AI_GENERATE_TRANSLATION_FAIL: `${listingNamespace}AI_GENERATE_TRANSLATION_FAIL`,
  AI_GET_JOB_STATUS: `${listingNamespace}AI_GET_JOB_STATUS`,
  AI_GET_JOB_STATUS_SUCCESS: `${listingNamespace}AI_GET_JOB_STATUS_SUCCESS`,
  AI_GET_JOB_STATUS_FAIL: `${listingNamespace}AI_GET_JOB_STATUS_FAIL`,
  AI_GET_LISTING_CONTENT: `${listingNamespace}AI_GET_LISTING_CONTENT`,
  AI_GET_LISTING_CONTENT_SUCCESS: `${listingNamespace}AI_GET_LISTING_CONTENT_SUCCESS`,
  AI_GET_LISTING_CONTENT_FAIL: `${listingNamespace}AI_GET_LISTING_CONTENT_FAIL`,
  AI_CLEAR_STATE: `${listingNamespace}AI_CLEAR_STATE`,
  AI_SET_GENERATED_CONTENT: `${listingNamespace}AI_SET_GENERATED_CONTENT`
};

export const payPerLead = {
  SET_LOADING: `${payPerLeadNamespace}SET_LOADING`,
  SET_TAB: `${payPerLeadNamespace}SET_TAB`,
  SET_SUB_TAB: `${payPerLeadNamespace}SET_SUB_TAB`,
  GET_LEADS: `${payPerLeadNamespace}GET_LEADS`,
  GET_LEADS_FAIL: `${payPerLeadNamespace}GET_LEADS_FAIL`,
  SET_LEADS_CLEAR: `${payPerLeadNamespace}SET_LEADS_CLEAR`,
  SET_LEAD_NO_INTEREST: `${payPerLeadNamespace}SET_LEAD_NO_INTEREST`,
  SET_LEAD_INTEREST: `${payPerLeadNamespace}SET_LEAD_INTEREST`,
  LEAD_PURCHASED: `${payPerLeadNamespace}LEAD_PURCHASED`,
  SET_LEAD_HIDE_FAIL: `${payPerLeadNamespace}SET_LEAD_HIDE_FAIL`,
  SET_HIDE_IN_FLIGHT: `${payPerLeadNamespace}SET_HIDE_IN_FLIGHT`,
  CLEAR_ERROR: `${payPerLeadNamespace}CLEAR_ERROR`
};

export const payPerLeadDetail = {
  SET_LOADING: `${payPerLeadDetailNamespace}SET_LOADING`,
  RESET_SUCCESS: `${payPerLeadDetailNamespace}RESET_SUCCESS`,
  RESET_ALL_SUCCESS: `${payPerLeadDetailNamespace}RESET_ALL_SUCCESS`,
  RESET_ERROR: `${payPerLeadDetailNamespace}RESET_ERROR`,
  GET_LEAD: `${payPerLeadDetailNamespace}GET_LEAD`,
  GET_LEAD_FAIL: `${payPerLeadDetailNamespace}GET_LEAD_FAIL`,
  BUY_LEAD: `${payPerLeadDetailNamespace}BUY_LEAD`,
  BUY_LEAD_FAIL: `${payPerLeadDetailNamespace}BUY_LEAD_FAIL`,
  HIDE_LEAD: `${payPerLeadDetailNamespace}HIDE_LEAD`,
  HIDE_LEAD_FAIL: `${payPerLeadDetailNamespace}HIDE_LEAD_FAIL`,
  CLEAR_LEAD: `${payPerLeadDetailNamespace}CLEAR_LEAD`,
  TOGGLE_MODAL: `${payPerLeadDetailNamespace}TOGGLE_MODAL`,
  CLEAR_ALL_MODALS: `${payPerLeadDetailNamespace}CLEAR_ALL_MODALS`,
  CHECK_COUPON: `${payPerLeadDetailNamespace}CHECK_COUPON`,
  CHECK_COUPON_FAIL: `${payPerLeadDetailNamespace}CHECK_COUPON_FAIL`,
  CHECK_COUPON_CLEAR: `${payPerLeadDetailNamespace}CHECK_COUPON_CLEAR`,
  CHECK_LOADING_LOADING: `${payPerLeadDetailNamespace}CHECK_LOADING_LOADING`
};

export const proBono = {
  SET_LOADING: `${proBonoNamespace}SET_LOADING`,
  GET_LEADS: `${proBonoNamespace}GET_LEADS`,
  GET_LEADS_FAIL: `${proBonoNamespace}GET_LEADS_FAIL`,
  SET_LEADS_CLEAR: `${proBonoNamespace}SET_LEADS_CLEAR`,
  SET_TAB: `${proBonoNamespace}SET_TAB`,
  SET_SUB_TAB: `${proBonoNamespace}SET_SUB_TAB`,
  TOGGLE_MODAL: `${proBonoNamespace}TOGGLE_MODAL`,
  CLEAR_ALL_MODALS: `${proBonoNamespace}CLEAR_ALL_MODALS`,
  GET_LEADS_STATS_SUCCESS: `${proBonoNamespace}GET_LEADS_STATS_SUCCESS`,
  GET_LEADS_STATS_FAIL: `${proBonoNamespace}GET_LEADS_STATS_FAIL`,
  SET_SELECTED_LISTING_ID: `${proBonoNamespace}SET_SELECTED_LISTING_ID`,
  SET_SELECTED_PLAN_DATA: `${proBonoNamespace}SET_SELECTED_PLAN_DATA`,
  SET_CASE_NO_INTEREST: `${proBonoNamespace}SET_CASE_NO_INTEREST`,
  SET_CASE_INTEREST: `${proBonoNamespace}SET_CASE_INTEREST`,
  SET_CASE_INTEREST_FAIL: `${proBonoNamespace}SET_CASE_INTEREST_FAIL`,
  TAKE_LEAD: `${proBonoNamespace}TAKE_LEAD`,
  TAKE_LEAD_SUCCESS: `${proBonoNamespace}TAKE_LEAD_SUCCESS`,
  TAKE_LEAD_FAIL: `${proBonoNamespace}TAKE_LEAD_FAIL`,
  SET_PENDING_TAKE: `${proBonoNamespace}SET_PENDING_TAKE`,
  RESET_ERROR: `${proBonoNamespace}RESET_ERROR`,
  MARK_LEAD_FULL: `${proBonoNamespace}MARK_LEAD_FULL`,
  RELEASE_LEAD_SUCCESS: `${proBonoNamespace}RELEASE_LEAD_SUCCESS`
};

export const proBonoDetail = {
  SET_LOADING: `${proBonoDetailNamespace}SET_LOADING`,
  RESET_SUCCESS: `${proBonoDetailNamespace}RESET_SUCCESS`,
  RESET_ALL_SUCCESS: `${proBonoDetailNamespace}RESET_ALL_SUCCESS`,
  RESET_ERROR: `${proBonoDetailNamespace}RESET_ERROR`,
  GET_LEAD: `${proBonoDetailNamespace}GET_LEAD`,
  GET_LEAD_FAIL: `${proBonoDetailNamespace}GET_LEAD_FAIL`,
  HIDE_LEAD: `${proBonoDetailNamespace}HIDE_LEAD`,
  HIDE_LEAD_FAIL: `${proBonoDetailNamespace}HIDE_LEAD_FAIL`,
  UNHIDE_LEAD: `${proBonoDetailNamespace}UNHIDE_LEAD`,
  UNHIDE_LEAD_FAIL: `${proBonoDetailNamespace}UNHIDE_LEAD_FAIL`,
  TAKE_LEAD: `${proBonoDetailNamespace}TAKE_LEAD`,
  TAKE_LEAD_FAIL: `${proBonoDetailNamespace}TAKE_LEAD_FAIL`,
  CLEAR_LEAD: `${proBonoDetailNamespace}CLEAR_LEAD`
};

export const callHistory = {
  GET_CALL_DATA_SUCCESS: `${callHistoryNamespace}GET_CALL_DATA_SUCCESS`,
  GET_CALL_DATA_FAIL: `${callHistoryNamespace}GET_CALL_DATA_FAIL`,
  SET_CALL_DATA_CLEAN: `${callHistoryNamespace}SET_CALL_DATA_CLEAN`
};

export const searchResult = {
  SET_LOADING: `${searchResultNameSpace}SET_LOADING`,
  GET_SEARCH_RESULT: `${searchResultNameSpace}GET_CALL_DATA_SUCCESS`,
  GET_SEARCH_RESULT_FAIL: `${searchResultNameSpace}GET_SEARCH_RESULT_FAIL`
};

export const performance = {
  SET_LOADING: `${performanceNamespace}SET_LOADING`,

  GET_LEADS_BY_MONTH: `${performanceNamespace}GET_LEADS_BY_MONTH`,
  GET_LEADS_BY_YEAR: `${performanceNamespace}GET_LEADS_BY_YEAR`,
  GET_LEADS_BY_WEEK: `${performanceNamespace}GET_LEADS_BY_WEEK`,
  GET_LEADS_BY_WEEK_SUCCESS: `${performanceNamespace}GET_LEADS_BY_WEEK_SUCCESS`,
  GET_LEADS_BY_YEAR_SUCCESS: `${performanceNamespace}GET_LEADS_BY_YEAR_SUCCESS`,
  GET_LEADS_BY_MONTH_SUCCESS: `${performanceNamespace}GET_LEADS_BY_MONTH_SUCCESS`,
  GET_LEADS_BY_LISTING_SUCCESS: `${performanceNamespace}GET_LEADS_BY_LISTING_SUCCESS`,
  GET_LEADS_BY_PRACTICE_AREA_SUCCESS: `${performanceNamespace}GET_LEADS_BY_PRACTICE_AREA_SUCCESS`,
  GET_LEADS_BY_WEEK_FAIL: `${performanceNamespace}GET_LEADS_BY_WEEK_FAIL`,
  GET_LEADS_BY_YEAR_FAIL: `${performanceNamespace}GET_LEADS_BY_YEAR_FAIL`,
  GET_LEADS_BY_MONTH_FAIL: `${performanceNamespace}GET_LEADS_BY_MONTH_FAIL`,
  GET_LEADS_BY_LISTING_FAIL: `${performanceNamespace}GET_LEADS_BY_LISTING_FAIL`,
  GET_LEADS_BY_PRACTICE_AREA_FAIL: `${performanceNamespace}GET_LEADS_BY_PRACTICE_AREA_FAIL`,
  GET_ERROR_DATA_FROM_SERVER: `${performanceNamespace}GET_ERROR_DATA_FROM_SERVER`
};

export const referralRequests = {
  GET_CASES_SUCCESS: `${referralRequestsNamespace}GET_CASES_SUCCESS`,
  GET_CASES_FAIL: `${referralRequestsNamespace}GET_CASES_FAIL`,
  SET_CASES_PRELOADER: `${referralRequestsNamespace}SET_CASES_PRELOADER`,
  SET_CASES_PRELOADER_IMPORT: `${referralRequestsNamespace}SET_CASES_PRELOADER_IMPORT`,
  SET_IMPORT_READY_PRELOADER: `${referralRequestsNamespace}SET_IMPORT_READY_PRELOADER`,
  TOGGLE_ACTIVITY_OF_MODAL: `${referralRequestsNamespace}TOGGLE_ACTIVITY_OF_MODAL`,
  CLEAR_ALL_MODALS: `${referralRequestsNamespace}CLEAR_ALL_MODALS`,
  SET_CLEAR_REFERRALS: `${referralRequestsNamespace}SET_CLEAR_REFERRALS`,
  GET_IMPORT_READY: `${referralRequestsNamespace}GET_IMPORT_READY`,
  GET_IMPORT: `${referralRequestsNamespace}GET_IMPORT`,
  // GROWTH-6580: the import calls fail separately, so that only the list's own request (GET_CASES_FAIL) can turn the list into an error.
  GET_IMPORT_FAIL: `${referralRequestsNamespace}GET_IMPORT_FAIL`,
  GET_NEW_REFERRAL_REQUEST: `${referralRequestsNamespace}GET_NEW_REFERRAL_REQUEST`,
  CLEAR_NEW_REFERRAL_REQUEST: `${referralRequestsNamespace}CLEAR_NEW_REFERRAL_REQUEST`,
  UPDATE_REFERRAL_REQUEST: `${referralRequestsNamespace}UPDATE_REFERRAL_REQUEST`,
  // GROWTH-8109: My Referrals v2 keeps its list in its own slice (state.referralRequests.requester).
  REQUESTER_CASES_REQUEST: `${referralRequestsNamespace}REQUESTER_CASES_REQUEST`,
  REQUESTER_CASES_SUCCESS: `${referralRequestsNamespace}REQUESTER_CASES_SUCCESS`,
  REQUESTER_CASES_FAIL: `${referralRequestsNamespace}REQUESTER_CASES_FAIL`,
  REQUESTER_CASE_PATCH: `${referralRequestsNamespace}REQUESTER_CASE_PATCH`,
  REQUESTER_CASE_HIDE: `${referralRequestsNamespace}REQUESTER_CASE_HIDE`,
  REQUESTER_CASE_RESTORE: `${referralRequestsNamespace}REQUESTER_CASE_RESTORE`,
  REQUESTER_CASE_FORGET: `${referralRequestsNamespace}REQUESTER_CASE_FORGET`,
  REQUESTER_CLEAR: `${referralRequestsNamespace}REQUESTER_CLEAR`
};

export const referralRequestDetail = {
  GET_CASE_SUCCESS: `${referralRequestDetailNameSpace}GET_CASE_SUCCESS`,
  GET_CASE_FAIL: `${referralRequestDetailNameSpace}GET_CASE_FAIL`,
  SET_CASE_PRELOADER: `${referralRequestDetailNameSpace}SET_CASE_PRELOADER`,
  CLEAR_ALL_MODALS: `${referralRequestDetailNameSpace}CLEAR_ALL_MODALS`,
  SET_CONTACT_INFO_DATA: `${referralRequestDetailNameSpace}SET_CONTACT_INFO_DATA`,
  TOGGLE_ACTIVITY_OF_MODAL: `${referralRequestDetailNameSpace}TOGGLE_ACTIVITY_OF_MODAL`,
  TOGGLE_ACTIVITY_MESSAGE_MODAL: `${referralRequestDetailNameSpace}TOGGLE_ACTIVITY_MESSAGE_MODAL`,
  GET_CASE_PRACTICES: `${referralRequestDetailNameSpace}GET_CASE_PRACTICES`,
  SUBMIT_CASE_DATA_SUCCESS: `${referralRequestDetailNameSpace}SUBMIT_CASE_DATA_SUCCESS`,
  CHANGE_CONTACT_INFO: `${referralRequestDetailNameSpace}CHANGE_CONTACT_INFO`,
  UPDATED_FOLLOWUPS: `${referralRequestDetailNameSpace}UPDATED_FOLLOWUPS`,
  UPDATED_FOLLOWUPS_FAIL: `${referralRequestDetailNameSpace}UPDATED_FOLLOWUPS_FAIL`,
  CHANGE_CONTACT_INFO_FAIL: `${referralRequestDetailNameSpace}CHANGE_CONTACT_INFO_FAIL`,
  SEND_MATCH_MESSAGE: `${referralRequestDetailNameSpace}SEND_MATCH_MESSAGE`,
  SEND_MATCH_MESSAGE_FAIL: `${referralRequestDetailNameSpace}SEND_MATCH_MESSAGE_FAIL`,
  SUBMIT_CASE_DATA_FAIL: `${referralRequestDetailNameSpace}SUBMIT_CASE_DATA_FAIL`,
  GET_PRACTICES: `${referralRequestDetailNameSpace}GET_PRACTICES`,
  GET_PRACTICES_FAIL: `${referralRequestDetailNameSpace}GET_PRACTICES_FAIL`,
  REMOVE_CASE_FAIL: `${referralRequestDetailNameSpace}REMOVE_CASE_FAIL`
};

export const questions = {
  GET_QA_SUCCESS: `${questionsNamespace}QA_GET_SUCCESS`,
  GET_MY_ANSWER: `${questionsNamespace}GET_MY_ANSWER`,
  GET_ALL_MY_ANSWER: `${questionsNamespace}GET_ALL_MY_ANSWER`,
  GET_MY_ANSWER_FAIL: `${questionsNamespace}GET_MY_ANSWER_FAIL`,
  GET_MY_QUESTIONS: `${questionsNamespace}GET_MY_QUESTIONS`,
  GET_MY_QUESTIONS_FAIL: `${questionsNamespace}GET_MY_QUESTIONS_FAIL`,
  GET_QA_FAIL: `${questionsNamespace}QA_GET_FAIL`,
  GET_CURRENT_QUESTION_ANSWER: `${questionsNamespace}GET_CURRENT_QUESTION_ANSWER`,
  SET_QA_PRELOADER: `${questionsNamespace}SET_QA_PRELOADER`,
  QA_MARK_SAVED: `${questionsNamespace}QA_MARK_SAVED`,
  QA_MARK_SAVED_SINGLE: `${questionsNamespace}QA_MARK_SAVED_SINGLE`,
  QA_MARK_UNSAVED_SINGLE: `${questionsNamespace}QA_MARK_UNSAVED_SINGLE`,
  QA_MARK_UNSAVED: `${questionsNamespace}QA_MARK_UNSAVED`,
  QA_UPDATE_ANSWERS: `${questionsNamespace}QA_UPDATE_ANSWERS`,
  CLEAN_QUESTIONS: `${questionsNamespace}CLEAN_QUESTIONS`,
  CLEAN_CURRENT_QUESTIONS: `${questionsNamespace}CLEAN_CURRENT_QUESTIONS`
};

export const messages = {
  GET_MESSAGES: `${messagesNamespace}GET_MESSAGES`,
  GET_MESSAGES_FAIL: `${messagesNamespace}GET_MESSAGES_FAIL`,
  APPEND_MESSAGES: `${messagesNamespace}APPEND_MESSAGES`,
  TOGGLE_LOADING: `${messagesNamespace}TOGGLE_LOADING`,
  GET_MESSAGE_DETAIL: `${messagesNamespace}GET_MESSAGE_DETAIL`,
  GET_MESSAGE_DETAIL_LOADING: `${messagesNamespace}GET_MESSAGE_DETAIL_LOADING`,
  GET_MESSAGE_DETAIL_FAIL: `${messagesNamespace}GET_MESSAGE_DETAIL_FAIL`,
  READ_MESSAGE: `${messagesNamespace}READ_MESSAGE`,
  UNREAD_MESSAGE: `${messagesNamespace}UNREAD_MESSAGE`,
  ARCHIVE_MESSAGE: `${messagesNamespace}ARCHIVE_MESSAGE`,
  UN_ARCHIVE_MESSAGE: `${messagesNamespace}UN_ARCHIVE_MESSAGE`,
  MESSAGE_ACTION_FAIL: `${messagesNamespace}MESSAGE_ACTION_FAIL`,
  CLEAR_MESSAGE_ACTION_ERRORS: `${messagesNamespace}CLEAR_MESSAGE_ACTION_ERRORS`,
  SEND_MESSAGE: `${messagesNamespace}SEND_MESSAGE`,
  SEND_MESSAGE_FAIL: `${messagesNamespace}SEND_MESSAGE_FAIL`,
  CLEAR_SEND_FAILURE: `${messagesNamespace}CLEAR_SEND_FAILURE`,
  SET_DRAFT: `${messagesNamespace}SET_DRAFT`,
  DISABLE_SUCCESS: `${messagesNamespace}DISABLE_SUCCESS`,
  SET_ACTIVE_BLOCKS: `${messagesNamespace}SET_ACTIVE_BLOCKS`,
  SET_ACTIVITY_FILTER: `${messagesNamespace}SET_ACTIVITY_FILTER`
};

export const teams = {
  SET_LOADING: `${teamsNameSpace}SET_LOADING`,
  TOGGLE_MODAL: `${teamsNameSpace}TOGGLE_MODAL`,
  ACTIVE_ACCESS: `${teamsNameSpace}ACTIVE_ACCESS`,
  GET_TEAMS: `${teamsNameSpace}GET_TEAMS`,
  GET_TEAMS_FAIL: `${teamsNameSpace}GET_TEAMS_FAIL`,
  REFRESH_OWNER_TEAM: `${teamsNameSpace}REFRESH_OWNER_TEAM`,
  REFRESH_OWNER_TEAM_FAIL: `${teamsNameSpace}REFRESH_OWNER_TEAM_FAIL`,
  REFRESH_MEMBER_TEAM: `${teamsNameSpace}REFRESH_MEMBER_TEAM`,
  REFRESH_MEMBER_TEAM_FAIL: `${teamsNameSpace}REFRESH_MEMBER_TEAM_FAIL`,
  REMOVE_ACCESS: `${teamsNameSpace}REMOVE_ACCESS`,
  REMOVE_ACCESS_FAIL: `${teamsNameSpace}REMOVE_ACCESS_FAIL`,
  ACCEPT_ACCESS: `${teamsNameSpace}ACCEPT_ACCESS`,
  ACCEPT_ACCESS_FAIL: `${teamsNameSpace}ACCEPT_ACCESS_FAIL`,
  INVITE_ACCESS: `${teamsNameSpace}INVITE_ACCESS`,
  INVITE_ACCESS_FAIL: `${teamsNameSpace}INVITE_ACCESS_FAIL`,
  REJECT_ACCESS: `${teamsNameSpace}REJECT_ACCESS`,
  REJECT_ACCESS_FAIL: `${teamsNameSpace}REJECT_ACCESS_FAIL`,
  UPDATE_ACCESS: `${teamsNameSpace}UPDATE_ACCESS`,
  UPDATE_ACCESS_FAIL: `${teamsNameSpace}UPDATE_ACCESS_FAIL`,
  CLEAR_ALL_MODALS: `${teamsNameSpace}CLEAR_ALL_MODALS`,
  CLEAR_ERROR: `${teamsNameSpace}CLEAR_ERROR`,
  CLEAR_TOAST: `${teamsNameSpace}CLEAR_TOAST`,
  GET_TEAMS_MEMBER: `${teamsNameSpace}GET_TEAMS_MEMBER`,
  GET_TEAMS_MEMBER_FAIL: `${teamsNameSpace}GET_TEAMS_MEMBER_FAIL`,
  SET_TEAM: `${teamsNameSpace}SET_TEAM`
};

export const publicListing = {
  SET_LOADING: `${publicListingsNameSpace}SET_LOADING`,
  CLEAR_ERROR: `${publicListingsNameSpace}CLEAR_ERROR`,
  CLEAR_ALL_MODALS: `${publicListingsNameSpace}CLEAR_ALL_MODALS`,
  TOGGLE_MODAL: `${publicListingsNameSpace}TOGGLE_MODAL`,
  GET_LISTINGS: `${publicListingsNameSpace}GET_LISTINGS`,
  GET_LISTINGS_FAIL: `${publicListingsNameSpace}GET_LISTINGS_FAIL`,
  REMOVE_FAVORITES: `${publicListingsNameSpace}REMOVE_FAVORITES`,
  ADD_FAVORITES: `${publicListingsNameSpace}ADD_FAVORITES`,
  ADD_FAVORITES_FAIL: `${publicListingsNameSpace}ADD_FAVORITES_FAIL`,
  SEND_MESSAGE: `${publicListingsNameSpace}SEND_MESSAGE`,
  SEND_MESSAGE_FAIL: `${publicListingsNameSpace}SEND_MESSAGE_FAIL`
};

export const partners = {
  SET_LOADING: `${partnersNameSpace}SET_LOADING`,
  SET_STATS: `${partnersNameSpace}SET_STATS`,
  SET_STATUS: `${partnersNameSpace}SET_STATUS`,
  SET_ERROR: `${partnersNameSpace}SET_ERROR`,
  CLEAR_ERROR: `${partnersNameSpace}CLEAR_ERROR`
};

export const following = {
  SET_LOADING: `${followingNameSpace}SET_LOADING`,
  GET_SCOPE: `${followingNameSpace}GET_SCOPE`,
  GET_SCOPE_FAIL: `${followingNameSpace}GET_SCOPE_FAIL`,
  ADD_LOCATION: `${followingNameSpace}ADD_LOCATION`,
  ADD_LOCATION_FAIL: `${followingNameSpace}ADD_LOCATION_FAIL`,
  REMOVE_LOCATION: `${followingNameSpace}REMOVE_LOCATION`,
  REMOVE_LOCATION_FAIL: `${followingNameSpace}REMOVE_LOCATION_FAIL`,
  SAVE_COMMUNITIES: `${followingNameSpace}SAVE_COMMUNITIES`,
  SAVE_COMMUNITIES_FAIL: `${followingNameSpace}SAVE_COMMUNITIES_FAIL`,
  GET_LANGUAGES: `${followingNameSpace}GET_LANGUAGES`,
  GET_LANGUAGES_FAIL: `${followingNameSpace}GET_LANGUAGES_FAIL`,
  SEARCH_PLACES: `${followingNameSpace}SEARCH_PLACES`,
  SEARCH_PLACES_FAIL: `${followingNameSpace}SEARCH_PLACES_FAIL`,
  CLEAR_PLACES: `${followingNameSpace}CLEAR_PLACES`
};
